/* unplugin-vue-components disabled */import script from "./ShowcasePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShowcasePanel.vue?vue&type=script&lang=ts&setup=true"

import "./ShowcasePanel.vue?vue&type=style&index=0&id=3724b495&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3724b495"]])

export default __exports__